<div class="view-permissions p-28 mt-4">
  <div class="flex flex-row justify-between items-center">
    <div class="fs-24 fw-700 mat-subtitle-2 mb-0">{{'GROUPS.VIEW_PERMISSIONS' | transloco}}</div>
    <mat-icon class="justify-items-end cursor-pointer icon-lg" [matDialogClose]="false" svgIcon="close"></mat-icon>
  </div>
  <mat-divider class="neutral-2 mt-20 mb-20"></mat-divider>
  <div class="flex mb-26">
    <div class="flex flex-col tenant-name">
      <div class="mat-subtitle-2 fs-16 fw-500 mb-8">{{'GROUPS.TENANT' | transloco}}</div>
      <div class="fw-600">{{role?.tenant | titlecase}}</div>
    </div>
    <div class="flex flex-col ml-24">
      <div class="mat-subtitle-2 fs-16 fw-500 mb-8">{{'GROUPS.ROLE' | transloco}}</div>
      <div class="fw-600">{{role?.name | titlecase}}</div>
    </div>
  </div>

  <div class="mb-12 mat-subtitle-2 fs-12 fw-700">
    {{ 'ROLES.RESOURCE' | transloco | uppercase }}
  </div>
  <div class="flex tab-layout">
    <div class="mr-16 pt-8 pb-8 pl-16 pr-16 tab-names cursor-pointer mat-subtitle-2 fs-16 fw-600" [ngClass]="{'selected': permission?.isSelected}"
      *ngFor="let permission of permissionsData" (click)="selectPermission(permission)">
        {{permission.header === ('ROLES.INSTANCE' | transloco) ? ('INSTANCE_DETAILS.INSTANCE' | transloco) : permission.header}}
    </div>
  </div>

  <div class="permissions-table mt-24 pb-8">
    <ng-container *ngIf="selectedPermission?.key !== 'instance' && selectedPermission?.key !== 'jumpboxes' && selectedPermission?.key !== 'pe-connections' && selectedPermission?.key !== 'authz' && selectedPermission?.key !== 'runbook' && selectedPermission?.key !== 'schedules' && selectedPermission?.key !== 'jobs'">
      <div class="others-header flex">
        <div class="permission-header mr-24 mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex pl-20">{{ 'ROLES.PERMISSIONS' | transloco }}</div>
      </div>
      <div class="pb-20">
        <ng-container *ngFor="let permission of selectedPermission.permissions">
          <div class="others-section flex" *ngIf="!permission.dataZonePermissions">
            <div class="permission pl-24 flex items-center mr-24 fw-500">
              {{permission?.header}}
            </div>
            <div class="element pl-24 flex items-center mr-24 fw-500">
              <mat-icon [svgIcon]="permission?.access ? 'done' : 'close'" [ngClass]="{'close': !permission?.access}"  class="icon-md-1"></mat-icon>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="dataZonePermissions(selectedPermission.permissions)">
      <div class="header flex">
        <div class="permission mr-24 mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex pl-20">{{ 'ROLES.PERMISSIONS' | transloco }}</div>
        <div class="nonpii mr-16 mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex justify-center">{{ (selectedPermission?.key === 'authz' ? 'ROLES.READ' : 'ROLES.NON_PII') | transloco }}</div>
        <div class="pii mr-16 mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex justify-center">{{ (selectedPermission?.key === 'authz' ? 'ROLES.CREATE' : 'ROLES.PII') | transloco }}</div>
        <div class="live mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex justify-center">{{ (selectedPermission?.key === 'authz' ? 'ROLES.UPDATE' : 'ROLES.PROD') | transloco }}</div>
      </div>
      <ng-container *ngFor="let permission of selectedPermission.permissions">
        <div class="body flex" *ngIf="permission.dataZonePermissions">
          <div class="permission pl-24 flex items-center mr-24 fw-500">
            {{permission?.header}}
          </div>
          <ng-container *ngFor="let element of permission.dataZonePermissions; let last = last">
            <div class="element flex items-center justify-center fw-500" [ngClass]="{'mr-16': !last}">
              <div>
                <mat-icon [svgIcon]="element?.access ? 'done' : 'close'" [ngClass]="element?.access && element?.infoDetails && element?.infoDetails?.length > 0 ? 'done' : !element?.access ? 'close' : ''"  class="icon-md-1"></mat-icon>
              </div>
              <span *ngIf="element?.access && element?.infoDetails && element?.infoDetails?.length > 0" class="info-icon">
                <mat-icon svgIcon="info" class="icon-sm cursor-pointer" [matMenuTriggerFor]="tooltipContent"></mat-icon>
              </span>
              <mat-menu #tooltipContent [xPosition]="'before'" class="roles-tooltip">
                <div class="p-12">
                  <div class="type-header mat-subtitle-2 fs-14 fw-600 pb-4 mb-8">{{'ROLES.INSTANCE_TYPE' | transloco}}</div>
                  <div class="fs-14 fw-500" *ngFor="let type of element?.infoDetails; let i = index">
                    {{i + 1}}.<span class="pl-4">{{ type === 'others' ? (type | titlecase) : (type | uppercase)}}</span>
                  </div>
                </div>
              </mat-menu>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>